import { Icon } from '~/components/ui/Icon';

/** A recusa que a tela mostra: a mensagem do backend, ou a do app quando ele não chegou lá. */
export function Alert({ message }: { message: string }): JSX.Element {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-[10px] border-hair border-negative bg-negative-tint px-3 py-2.5 text-[13px] text-ink"
    >
      <Icon name="warn" size={16} color="var(--rx-negative)" />
      <span>{message}</span>
    </div>
  );
}
